export const screeningPages = {
  DADOS_CADASTRO: {
    route: '/triagem/confirmacao',
    name: 'confirmacao',
    title: 'Seus dados',
  },
  SINTOMAS: {
    route: '/triagem/sintomas',
    name: 'sintomas',
    title: 'Sintomas',
  },
  DOENCAS_CRONICAS_MEDICAMENTOS: {
    route: '/triagem/historico-de-saude',
    name: 'historico-de-saude',
    title: 'Histórico de saúde',
  },
  ALERGIAS_MEDICAMENTO: {
    route: '/triagem/alergias',
    name: 'alergias',
    title: 'Alergias',
  },
  ARQUIVOS_COMPARTILHADOS: {
    route: '/triagem/arquivos',
    name: 'arquivos',
    title: 'Arquivos compartilhados',
  },
  DADOS_TRIAGEM: {
    route: '/triagem/verificacao-triagem',
    name: 'verificacao-triagem',
    title: 'Dados da triagem',
  },
}
